import React, { Component, Fragment } from 'react';
import './editLog.css';
import moment from 'moment';
import { date_format } from '../../../../server/constants';

class EditLog extends Component {
    constructor(props) {
        super(props);

    }
    renderSortedList = (list) => {
        const groupList = list.reduce((acc, item) => {
            const tn = item.editTn;
            if (!acc[tn]) {
                acc[tn] = [];
            }
            acc[tn].push(item);
            return acc;
        }, {});

        const sortedList = Object.keys(groupList).sort((a, b) => b - a);
        return <ul style={{ paddingLeft: '20px' }}>{
            sortedList.map((tn, index) => {
                return (
                    <li>
                        {groupList[tn].map((item, idx) => {
                            return (
                                <div className='row' key={idx} style={{ padding: '5px 0' }}>
                                    <div className='col-md-12'><i class="fa fa-certificate" aria-hidden="true"></i> <b>{item.fieldName}</b> field value changed from <b>{item.oldValue || '--'}</b> to <b>{item.newValue || '--'}</b></div>
                                    <div className='col-md-12' style={{ marginLeft: '20px' }}><b>User Explanation:</b> {item.editReason}</div>
                                </div>
                            )
                        })}
                    </li>
                )
            })
        }</ul>
    }
    renderTable = (dataObj) => {
        const sortedKeys = Object.keys(dataObj).sort((a, b) => new Date(b) - new Date(a));
        return (
            <table className='table'>
                <tbody>
                    {
                        sortedKeys.length === 0 ? (
                            <tr>
                                <td>No edit logs available.</td>
                            </tr>
                        ) : <Fragment>{sortedKeys.map((date, index) => {
                            const _dt = new Date(Number(date));
                            return (
                                <tr key={index}>
                                    <td width='5%'>
                                        {index + 1}
                                    </td>
                                    <td>
                                        <div>{`${((dataObj[date] || [])[0] || {}).createdBy || ''} [${moment(_dt).format(date_format() + ' hh:mm:ss')}]`}</div>
                                        {this.renderSortedList(dataObj[date])}
                                    </td>
                                </tr>
                            )
                        })}</Fragment>
                    }

                </tbody>
            </table>
        )
    }
    render() {
        const { data } = this.props;
        const dateWiseGroup = data.reduce((acc, item) => {
            const date = item.createdOn;
            if (!acc[date]) {
                acc[date] = [];
            }
            acc[date].push(item);
            return acc;
        }, {});

        return (
            <div>
                {this.renderTable(dateWiseGroup)}
            </div>


        );
    }
}

export default EditLog;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/EditLog/index.jsx